import { analyticsAndMarketingCookieName } from "@flow/plugins/civic_uk_cookie_control/frontend/member/CookieControl";
import { CookieConsentContext } from "@flow/plugins/civic_uk_cookie_control/frontend/member/CookieControlContext";
import { PostHogProvider } from "posthog-js/react";
import React, { useContext } from "react";

export const PostHogProviderWrapper = ({ children }: { children: React.ReactNode }) => {
  const cookieConsentContext = useContext(CookieConsentContext);

  if (
    POSTHOG_HOST &&
    POSTHOG_KEY &&
    !window.location.host.includes("127.0.0.1") &&
    !window.location.host.includes("localhost") &&
    cookieConsentContext?.cookieConsents?.[analyticsAndMarketingCookieName]
  ) {
    const posthogOptions = {
      api_host: POSTHOG_HOST,
      secure_cookie: true, // Posthog marks cookies as 'secure' so that they are only transported over https
      cross_subdomain_cookie: false, // ensures Posthog sets cookies separately per subdomain, e.g. act. and act-staging.
      session_recording: {
        maskAllInputs: true, // prevents any user input being recorded on Posthog servers
        maskTextSelector: ".posthog-mask-text", // masks UI text displaying sensitive info, like supporter name
      },
    };

    return (
      <PostHogProvider apiKey={POSTHOG_KEY} options={posthogOptions}>
        {children}
      </PostHogProvider>
    );
  } else {
    return <>{children}</>;
  }
};
